import { useQuery, QueryFunction, UseQueryResult } from '@tanstack/react-query';
import { Section } from '@twiliointernal/org/twilio/e2-commons/shared/definitions';

import { constants } from './definitions';
import { SupportApi } from '../../clients';
import logger from '../../../lib/logger';

export const fetchSectionByIdFnKey = 'articles-by-section';

const fetchSectionById: QueryFunction = async ({ queryKey }) => {
  const [, sectionId] = queryKey as [string, string];
  const emptySection = {};

  try {
    const { data } = await SupportApi.getSectionById({
      sectionId,
    });

    const section = data?.section ?? emptySection;

    return section;
  } catch (err) {
    logger.error(`${constants.LOG_PREFIX}::${err}`);
  }
};

export const useGetSectionById = ({ sectionId }): UseQueryResult<Section> => {
  const queryKey = [constants.fetchSectionByIdFnKey, sectionId];
  const queryFn = fetchSectionById;

  return useQuery({
    queryKey,
    queryFn,
    retry: false,
  });
};

export default useGetSectionById;
